<template>
  <div>
    <Preloader :loading="isTicketsLoading" />
    <ComingSoon
      v-if="isTicketsEmpty"
      entity="Ticketing"
      :text="`Ticketing opens in ${timeLeftToTicketing} days`"
    />
    <section v-if="tickets && tickets.length" class="tickets padding-x">
      <Heading noDecoration type="h2" text-align="center" class="mb-3">
        Tickets
      </Heading>
      <p class="tickets__text">
        ACCESS THE CONFERENCE BY EITHER REDEEMING A SPONSOR CODE OR PURCHASING A
        TICKET
        <!--        If you already have a ticket, you can
                <a :href="`${baseUrl}virtualconf/#/login`"> login to event here </a>-->
      </p>

      <div
        class="tickets__list"
        :class="{ 'tickets__list--odd': tickets.length % 2 }"
      >
        <Ticket
          v-for="ticket in tickets"
          :key="ticket.type"
          v-show="!ticket.is_sponsor"
          :ticket="ticket"
          class="tickets__ticket"
        />
      </div>
      <!--      <Heading noDecoration type="h4" text-align="center" class="mt-4 mb-2">-->
      <!--        Only interested in talks?-->
      <!--      </Heading>-->
      <!--      <p class="tickets__text">-->
      <!--                You can get access to online conference for free (talks and chat with-->
      <!--                other attendees included). Please-->
      <!--                <a :href="`${baseUrl}virtualconf/#/login`"> sign up here </a>-->
      <!--      </p>-->
    </section>
  </div>
</template>

<script>
import moment from "moment";
import { mapActions, mapState } from "vuex";
import Heading from "@/components/common/Heading";
import Ticket from "@/components/common/TicketCard";
import Preloader from "@/components/common/Preloader";
import ComingSoon from "@/components/common/ComingSoon";

export default {
  name: "Tickets",
  props: {
    start: {
      type: String,
      default: "",
    },
  },
  components: {
    ComingSoon,
    Preloader,
    Heading,
    Ticket,
  },
  data: () => ({
    isTicketsLoading: false,
    isTicketsEmpty: false,
    tickets: [],
  }),
  computed: {
    ...mapState(["currentEventID"]),
    baseUrl() {
      return process.env.VUE_APP_BASE_URL.split("api/")[0];
    },
    timeLeftToTicketing() {
      const now = moment();

      const openingDate = moment(this.start).subtract(30, "days");
      const datesDiff = moment(openingDate).valueOf() - now.valueOf();
      return moment(datesDiff).format("DDD");
    },
  },
  mounted() {
    this.isTicketsLoading = true;
    this.getTickets();
  },
  methods: {
    ...mapActions(["GET"]),

    getTickets() {
      return this.GET({
        route: `ticketing/public/event/${this.currentEventID}/ticket_type`,
      })
        .then((resp) => {
          if (!resp.data) this.isTicketsEmpty = true;
          this.tickets = resp.data;
          this.isTicketsLoading = false;
        })
        .catch((err) => {
          console.log(err);
          this.isTicketsLoading = false;
        });
    },
  },
};
</script>

<style lang="scss">
@import "@/assets/scss/_variables";

.tickets {
  $self: &;

  padding-top: 32px;

  &__text {
    width: 70%;
    margin: 0 auto;
    text-align: center;
    letter-spacing: 0.05em;
  }

  &__text:first-of-type {
    margin-bottom: 55px;
  }

  &__list {
    display: grid;
    grid-gap: 64px 0;
  }

  @media (min-width: $media-xs) {
    &__list {
      grid-gap: 50px 16px;
      grid-template-columns: repeat(2, 1fr);

      &--odd {
        #{$self}__ticket:first-child {
          grid-column: span 2;
        }
      }
    }
  }

  @media (min-width: $media-sm) {
    padding-top: 122px;

    &__text:first-of-type {
      margin-bottom: 60px;
    }

    &__list {
      grid-gap: 50px 24px;
      grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));

      &--odd {
        #{$self}__ticket:first-child {
          grid-column: auto;
        }
      }
    }
  }

  @media (min-width: $media-lg) {
    &__text:first-of-type {
      margin-bottom: 80px;
    }
  }
}
</style>
